import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const fluffyJawsClient = createApiClient(
  actions["exd-storyteller-ai/fluffyjaws"],
);

/**
 * Ask FluffyJaws a question via the backend /fluffyjaws/ask endpoint.
 *
 * Pass `sessionId` (returned by a previous call) to continue the same
 * conversation. When a session is reused, set `autoInitialize` to false so the
 * backend does not open a fresh session.
 * @param {Object} body
 * @param {string} body.query - The question to ask
 * @param {string} [body.sessionId] - MCP session id to continue a conversation
 * @param {boolean} [body.autoInitialize] - Whether to initialize a new session
 * @param {string} [body.fluffyPackUuid] - Optional FluffyPack UUID
 * @param {Object} [options] - Request options (e.g. { signal })
 * @returns {Promise<Object>} { ok, sessionId, contentType, text, mcp }
 */
export const askFluffyJaws = async (body, options = {}) => {
  const response = await fluffyJawsClient.post(
    "/ask",
    {
      query: body.query,
      ...(body.sessionId ? { sessionId: body.sessionId } : {}),
      ...(body.autoInitialize !== undefined
        ? { autoInitialize: body.autoInitialize }
        : {}),
      ...(body.fluffyPackUuid ? { fluffyPackUuid: body.fluffyPackUuid } : {}),
    },
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to ask FluffyJaws", { cause: response });
  }

  return response.data;
};
